import { useTranslation } from 'react-i18next';

import { Typography } from '@speeki/global-ui-components';

import { SuccessTemplate } from '@components/templates/SuccessTemplate/SuccessTemplate';

export const RequestResetMfaPage = () => {
    const { t } = useTranslation();

    const NotReciveEmailText = (
        <>
            <Typography.TextH4_20_28>
                {t('NOT_RECEIVE_MFA_RESET_EMAIL')}
            </Typography.TextH4_20_28>
            <Typography.TextH4_20_28>
                {t('CHECK_JUNK_EMAIL_FOLDER')}
            </Typography.TextH4_20_28>
        </>
    );

    return (
        <SuccessTemplate
            texts={[t('CHECK_INBOX_TO_RESET_MFA'), NotReciveEmailText]}
            title={t('EMAIL_SENT_TO_RECOVERY_EMAIL')}
        />
    );
};
